import { useTranslation } from 'react-i18next';
import { Building2 } from 'lucide-react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { useGym } from '@/contexts/gym-context';
import { useUser } from '@/contexts/user-context';
import { useView } from '@/contexts/view-context';

/**
 * Global gym picker rendered in the top bar.
 * Visible for admin/reception views when the user has more than one gym.
 */
export function GymSwitcher() {
  const { t } = useTranslation();
  const { gyms, selectedGym, selectGym } = useGym();
  const { user } = useUser();
  const { viewMode } = useView();

  // Restrict to the user's assigned gyms when applicable
  const userGyms =
    user && user.gym ? gyms.filter((gym) => user.gym.includes(gym._id)) : gyms;

  const canSwitch = viewMode === 'admin' || viewMode === 'reception';
  if (!canSwitch || userGyms.length <= 1) return null;

  const selectedName =
    userGyms.find((gym) => gym._id === selectedGym)?.name || t('dashboard.selectGym');

  return (
    <Select value={selectedGym} onValueChange={selectGym}>
      <SelectTrigger
        className="h-9 w-[140px] gap-2 sm:w-[180px]"
        aria-label={t('dashboard.selectGym')}
      >
        <Building2 className="h-4 w-4 shrink-0 text-muted-foreground" />
        <SelectValue placeholder={t('dashboard.selectGym')}>
          <span className="truncate">{selectedName}</span>
        </SelectValue>
      </SelectTrigger>
      <SelectContent>
        {userGyms.map((gym) => (
          <SelectItem key={gym._id} value={gym._id}>
            {gym.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
